import { render } from "./ProductCardList.vue?vue&type=template&id=5605d54b"
import script from "./ProductCardList.vue?vue&type=script&lang=js"
export * from "./ProductCardList.vue?vue&type=script&lang=js"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__